import React from "react";
import { Button, Modal, Container, Row, Col } from "react-bootstrap";
import I18n from "i18n-js";

const TermsAndConditions = ({ show, onHide }) => (
  <Modal
    size="lg"
    show={show}
    onHide={onHide}
    backdrop="static"
    keyboard={false}
    className="terms-and-conditions-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title className="w-100 text-center">
        {I18n.t("terms.title")}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Container>
        <Row className="d-flex flex-column">
          <Col>
            <p>{I18n.t("terms.disclaimer")}</p>
          </Col>
          <Col>
            <h5>{I18n.t("terms.privacy_policy.title")}</h5>
            <p>
              {I18n.t("terms.privacy_policy.disclaimer")} &nbsp;
              <a href="https://heyvicky.com/privacy" target="_blank">
                {I18n.t("terms.actions.more_about")}
              </a>
            </p>
          </Col>

          <Col>
            <h5>{I18n.t("terms.terms_of_service.title")}</h5>
            <p>
              {I18n.t("terms.terms_of_service.agreement.first")}
              <br />
              {I18n.t("terms.terms_of_service.agreement.second")} &nbsp;
              <a href="https://heyvicky.com/terms" target="_blank">
                {I18n.t("terms.actions.more_about")}
              </a>
            </p>
          </Col>

          <Col>
            <h5>{I18n.t("terms.faq.title")}</h5>
            <p>
              {I18n.t("terms.faq.secure_info.question")}
              <br />
              {I18n.t("terms.faq.secure_info.answer")} &nbsp;
              <a href="https://heyvicky.com/terms" target="_blank">
                {I18n.t("terms.actions.more_about")}
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </Modal.Body>

    <Modal.Footer>
      <Button
        variant="primary"
        className="submit-btn"
        onClick={onHide}
      >
        {I18n.t("terms.actions.understood")}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default TermsAndConditions;
